var map = {
	"./buy-active.png": "0VH6",
	"./category-active.png": "HwW9",
	"./commondisease-active.png": "/2DK",
	"./daily-warn-active.png": "GR0m",
	"./dorm-active.png": "ePod",
	"./dorm-warn-active.png": "y2su",
	"./expellinginsects-active.png": "5arC",
	"./home-active.png": "X4/I",
	"./ill-warn-active.png": "og3E",
	"./log-active.png": "OXQ0",
	"./order-active.png": "Go43",
	"./pet-active.png": "i8o8",
	"./product-brand-active.png": "I1r0",
	"./product-list-active.png": "xvOR",
	"./purchase-active.png": "40C5",
	"./role-active.png": "CdVW",
	"./sms-new-active.png": "r0Ur",
	"./staff-active.png": "bdtf",
	"./stage-warn-active.png": "JB6V",
	"./store-active.png": "ICOI",
	"./store-warn-active.png": "D+Hb",
	"./sysShop-active.png": "S3Pu",
	"./systen-set-active.png": "oJHC",
	"./ums-admin-active.png": "6rXd",
	"./vaccine-active.png": "Z/Pu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YzOD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu ^\.\/.*\-active\.png$
// module id = YzOD
// module chunks = 58